import React, {cloneElement, useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {useMutation, useQuery} from "@apollo/react-hooks";
import {DELETE_INTRODUCTIONS, GET_INTRODUCTIONS} from "../../database/queries/introductionQueries";
import {SizeMe} from "react-sizeme";
import MaterialTable from "material-table";
import tableIcons from "../../constants/tableIcons";
import {notify} from "../../utils/notify";
import useLayoutStore from "../../layoutStore";
import PageBar from "../Common/PageBar";
import {Route, Switch, useHistory, useParams, useRouteMatch} from "react-router-dom";
import CalendarStrings from "../../constants/calendarStrings";
import Moment from "react-moment";

const useStyles = makeStyles(theme => ({
    grow: {
        flexGrow: 1,
    },
}));

const IntroductionList = props => {
    const classes = useStyles();
    // eslint-disable-next-line no-unused-vars
    const [searchStr, setSearchStr] = useState('');
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedObj, setSelectedObj] = useState({});
    const [introductions, setIntroductions] = useState(null);
    const [globalLayoutState] = useLayoutStore();
    let {url} = useRouteMatch();
    let {introductionId} = useParams();
    const history = useHistory();

    const columns = [
        {
            title: 'Direction',
            field: 'introductionDirection',
            lookup: {to: 'I introduced them to', by: 'I was introduced by'}
        },
        {title: 'Introduction Name', field: 'introductionContactName'},
        {title: 'Linkedin Id', field: 'introductionContactLinkedinId'},
        {
            title: 'When',
            render: r => <Moment calendar={CalendarStrings}>{r.createdAt}</Moment>,
        },
        {title: 'Note', field: 'introductionNote',},
    ];

    const {loading: getIntroductionsLoading, error: getIntroductionsError, data: getIntroductionsData, refetch: getIntroductionsRefetch} = useQuery(GET_INTRODUCTIONS, {
        skip: !props.editId || props.editId === 'new',
        variables: {
            contactId: props.editId,
            orderList: ['updatedAt DESC']
        },
    });

    const [deleteIntroductions, {error: deleteIntroductionsError}] = useMutation(DELETE_INTRODUCTIONS);

    const handleRefresh = () => {
        getIntroductionsRefetch();
    };

    const handleDelete = () => {
        const selectedIds = selectedRows.map(row => row.introductionId);
        deleteIntroductions({
            variables: {deleteIntroductionIds: selectedIds}
        }).then(deleteIntroductionsResult => {
            if (deleteIntroductionsResult.data.deleteIntroductions.returnCode === 0) {
                notify('deleteIntroductions', 'info', deleteIntroductionsResult.data.deleteIntroductions.message);
            } else {
                notify('deleteIntroductions', 'error', deleteIntroductionsResult.data.deleteIntroductions.message);
            }
            getIntroductionsRefetch();
        }).catch(e => {
            notify('deleteIntroductions', 'error', e.message);
            getIntroductionsRefetch();
        })
    };

    useEffect(() => {
        getIntroductionsRefetch();
    }, [getIntroductionsRefetch]);

    useEffect(() => {
        if (deleteIntroductionsError) notify('deleteIntroductionError', 'error', deleteIntroductionsError.message);
        if (getIntroductionsError) notify('getIntroductionsError', 'error', getIntroductionsError.message);
    }, [deleteIntroductionsError, getIntroductionsError]);

    useEffect(() => {
        if (getIntroductionsData && getIntroductionsData.introductions) {
            setSelectedRows([]);
            setSelectedObj({});
            setIntroductions(getIntroductionsData.introductions);
        }
    }, [getIntroductionsData]);

    useEffect(() => {
    }, []);

    return (
        <Switch>
            <Route exact path={`${url}`}>
                <PageBar
                    title={'Introductions'}
                    handleRefresh={handleRefresh}
                    handleAdd={() => {
                        console.log('## SVR introductionList ## changing history', `${url}/new`);
                        history.push(`${url}/new`);
                    }}
                    handleEdit={() => {
                        console.log('## SVR introductionList ## changing history', `${url}/${selectedObj.introductionId}`);
                        history.push(`${url}/${selectedObj.introductionId}`);
                    }}
                    editDisabled={selectedRows.length !== 1}
                    tagDisabled={selectedRows.length === 0}
                    handleDelete={handleDelete}
                    deleteDisabled={selectedRows.length === 0}
                    exportDisabled={selectedRows.length === 0}
                    showLoading={getIntroductionsLoading}
                >
                </PageBar>
                <div className={classes.root}>
                    {introductions && (
                        <SizeMe>
                            {({size}) => {
                                let height = size.height;
                                if (!height) height = window.innerHeight;

                                const tableOptions = {
                                    actionsColumnIndex: -1,
                                    header: true,
                                    maxBodyHeight: height - (globalLayoutState.tabBarHeight + 250),
                                    padding: 'dense',
                                    paging: false,
                                    selection: true,
                                    toolbar: false,
                                };

                                return (
                                    <MaterialTable
                                        columns={columns}
                                        data={introductions}
                                        icons={tableIcons}
                                        options={tableOptions}
                                        onSearchChange={(str) => {
                                            setSearchStr(str);
                                        }}
                                        onSelectionChange={(rows) => {
                                            setSelectedRows(rows);
                                            if (rows.length === 1) {
                                                setSelectedObj(rows[0])
                                            } else {
                                                setSelectedObj({})
                                            }
                                        }}
                                    />
                                );
                            }}
                        </SizeMe>
                    )}
                </div>
            </Route>
            <Route path={`${url}/:introductionId`}>
                {cloneElement(props.parent.routes.edit.component, {
                    ...props,
                    parentRefresh: () => {
                        getIntroductionsRefetch()
                    },
                    introductionId: introductionId,
                    editType: 'introduction',
                    parent: props.parent.routes.edit
                })}
            </Route>
        </Switch>
    )
};

export default IntroductionList
